export default {
    usuarioPredefinido: state => {
        return state.user.cpf && state.user.nome && state.user.email
    },
    ehCFC: state => {
        return state?.roles?.indexOf('Perfil.CFC') > -1
    }
}